import { createFileRoute } from "@tanstack/react-router";
import { loadLegacyContent, LegacyContent, legacyHead } from "@/lib/legacy-content";

export const Route = createFileRoute("/general-surgery")({
  loader: () => loadLegacyContent("general-surgery"),
  head: ({ loaderData }) =>
    loaderData ? legacyHead("/general-surgery", loaderData) : { meta: [{ title: "General Surgery — Healic" }] },
  component: () => <LegacyContent payload={Route.useLoaderData()} />,
});
